import { ElementProps } from '@/components/sections/builder/types';
import { ImageWithTextElementDataType } from '@/components/sections/builder/elements/body/image-with-text/types';
import { WrapperChild } from '@/components/sections/builder/wrapper';
import clsx from 'clsx';
import DynamicImage from '@/components/commons/dynamic-image';

export default function ElementContent({ element, preview }: ElementProps) {
  const childs = element.childs;
  const data = element.data as ImageWithTextElementDataType;

  const backgroundAnimationClass = `image_animation-${data.backgroundAnimation || 'none'}`;

  return (
    <>
      <section className='bg_section'>
        <div className='theme_layout_page_width container-padding mx-auto overflow-hidden duration-100'>
          <div
            className={clsx(
              'flex h-full flex-col overflow-hidden lg:flex-row',
              data.roundedCard === true && 'rounded-lg',
              data.imagePosition === 'right' &&
                data.contentOverlap === 'overlap' &&
                '[&>*:nth-child(1)]:mx-8 [&>*:nth-child(1)]:-mt-8 lg:[&>*:nth-child(1)]:mx-0 lg:[&>*:nth-child(1)]:-mt-0 lg:[&>*:nth-child(1)]:translate-x-4 lg:[&>*:nth-child(1)]:translate-y-4 lg:[&>*:nth-child(2)]:-translate-x-4 lg:[&>*:nth-child(2)]:-translate-y-4',
              data.imagePosition === 'left' &&
                data.contentOverlap === 'overlap' &&
                '[&>*:nth-child(1)]:mx-8 [&>*:nth-child(1)]:-mt-8  lg:[&>*:nth-child(1)]:mx-0 lg:[&>*:nth-child(1)]:-mt-0 lg:[&>*:nth-child(1)]:-translate-x-4 lg:[&>*:nth-child(1)]:translate-y-4 lg:[&>*:nth-child(2)]:-translate-y-4 lg:[&>*:nth-child(2)]:translate-x-4'
            )}
          >
            <div className='text_color_container bg_container h-full flex-1'>
              <div
                className={clsx(
                  'relative flex flex-col lg:h-[350px]',
                  data.contentPosition === 'top' && 'justify-start',
                  data.contentPosition === 'middle' && 'justify-center',
                  data.contentPosition === 'bottom' && 'justify-end'
                )}
              >
                <div
                  className={clsx(
                    'bg_container flex flex-col p-6 text-center',
                    data.contentAlign === 'left' && 'lg:items-start lg:text-left',
                    data.contentAlign === 'center' && 'lg:items-center lg:text-center',
                    data.contentAlign === 'right' && 'lg:items-end lg:text-right',
                    data.contentAlignMobile === 'left' && 'items-start text-left',
                    data.contentAlignMobile === 'center' && 'items-center text-center',
                    data.contentAlignMobile === 'right' && 'items-end text-right',
                    data.contentOverlap === 'overlap' &&
                      data.contentAlign === 'right' &&
                      data.imagePosition === 'right' &&
                      'lg:pr-12'
                  )}
                >
                  {(childs || []).map((child) => (
                    <WrapperChild
                      child={{
                        ...child,
                        parentData: data,
                      }}
                      parentType={element.type}
                      key={child.id}
                      preview={preview}
                    />
                  ))}
                </div>
              </div>
            </div>
            <div
              className={clsx('overflow-hidden ', {
                'order-first': data.imagePosition === 'left',
                'order-last': data.imagePosition === 'right',
              })}
            >
              {data.image && (
                <div
                  className={clsx(
                    'image_width_section relative items-center justify-center overflow-clip lg:mt-0',
                    data?.imageHeight === 'adapt' && 'h-[350px]',
                    data?.imageHeight === 'small' && 'h-[192px] md:h-[350px] ',
                    data?.imageHeight === 'medium' && 'h-[294px] md:h-[350px]',
                    data?.imageHeight === 'large' && 'h-[333px] md:h-[350px]'
                  )}
                  data-animation='true'
                >
                  <DynamicImage
                    src={data.image}
                    fill
                    alt='mockup'
                    className={clsx(
                      'image_width_section h-[350px] bg-center bg-no-repeat object-cover ',
                      backgroundAnimationClass,
                      data.backgroundAnimation === 'ambient_movement' && 'animate-zoomSlideDown'
                    )}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <style jsx>
        {`
          .container-padding {
            padding-top: ${data.padding?.top || 0}px;
            padding-bottom: ${data.padding?.bottom || 0}px;
            padding-left: ${data.padding?.left || 0}px;
            padding-right: ${data.padding?.right || 0}px;
          }

          .image_width_section {
            width: 100%;
          }

          @media (max-width: 767px) {
            .container-padding {
              padding-left: 8px;
              padding-right: 8px;
            }
          }

          @media (min-width: 768px) and (max-width: 1023px) {
            .container-padding {
              padding-left: 12px;
              padding-right: 12px;
            }
          }

          @media (min-width: 1024px) {
            .container-padding {
              padding-top: ${data.padding?.top || 20}px;
              padding-bottom: ${data.padding?.bottom || 20}px;
              padding-left: ${data.padding?.left || 20}px;
              padding-right: ${data.padding?.right || 20}px;
            }

            .image_width_section {
              width: ${data.imageWidthSlider || 375}px;
            }
          }

          .bg_section {
            background-color: ${data.sectionColorScheme?.background || 'white'};
          }

          .bg_container {
            background-color: ${data.containerColorScheme?.background || 'white'};
          }

          .text_color_container {
            color: ${data.containerColorScheme?.text || '#52535B'} !important;
          }

          .image_animation-zoom_on_scroll {
            transform: scale(1);
            animation-range: cover 0% cover 100%;
            animation: zoom_scroll_animation linear;
            animation-timeline: view();
            animation-iteration-count: 1;
          }

          @keyframes zoom_scroll_animation {
            to {
              transform: scale(1.5);
            }
          }
        `}
      </style>
    </>
  );
}
